import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './utils/flexible'
import './assets/css/base.css' // 引入公共样式
import Vant from 'vant';
import 'vant/lib/index.css';
import http from './utils/http'

Vue.use(Vant);

Vue.config.productionTip = false
Vue.prototype.$http = http;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
